import { render, staticRenderFns } from "./AiReportingChat.vue?vue&type=template&id=3ba1f5ff&scoped=true&"
import script from "./AiReportingChat.vue?vue&type=script&setup=true&lang=js&"
export * from "./AiReportingChat.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AiReportingChat.vue?vue&type=style&index=0&id=3ba1f5ff&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba1f5ff",
  null
  
)

export default component.exports